import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../core/../core/services/popup/popup.service';

@Injectable({
  providedIn: 'root'
})

export class EditProfileService {

  private url = environment.do_services_sb_url;
  private editProfileUrl: string = 'gigya/gigyaEditProfile';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private authService: AuthService,
              private popupService: PopupService, private route: Router) { }

  editUserProfile(profileInfo: string): Observable<any> {
    const options = {
      headers: this.headers
    };
    return this.http.put(this.url + this.editProfileUrl, profileInfo, options).pipe(
      map((response: any) => {
        const run = response;
        return run;
      }),
      catchError((error: any) => {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
          return throwError(() => error);
        }
        if(error.status === 401) {
          const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
            data: { message: 'Unauthorized Request - Your Session has expired' }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.authService.logout().subscribe(() => {
              this.route.navigate(['/home']);
            });
          });
          return throwError(() => new Error('Unauthorized Request - Session expired'));
        }
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
      })
    );
  }
  
}